import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';

import heroImage from '../../images/homepage-hero.jpg';
import laptopIcon from '../../images/laptop.svg';
import desktopIcon from '../../images/desktop.svg';

const HeroArea = () => (
  <div className="HeroBanner" style={{ backgroundImage: `url(${heroImage})` }}>
    <div className="HeroBanner-Warp">
      <Container>
        <Row>
          <Col md={8}>
            <h1 className="HeroBanner-Title">Onsite Computer Specialist</h1>
            <p className="HeroBanner-TitleSub">Book Online to save 10% OFF on Weekdays and 20% OFF on Weekends.</p>
            <Card className="HeroBanner-BookWarp">
              <Card.Body>
                <Row className="align-items-center">
                  <Col xs={3}>
                    <ul className="HeroBanner-BookWarp__Icons">
                      <li>
                        <Image fluid src={laptopIcon} />
                      </li>
                      <li>
                        <Image fluid src={desktopIcon} />
                      </li>
                    </ul>
                  </Col>
                  <Col xs={9}>
                    <p className="text-dark">We are specialist for all types of Computers! Our technicians are highly experienced in Desktop and Laptop Computer fixing. Also call us for your TV, Phone, Software, Hardware, Data Recovery, Networking and more.</p>
                    <Link 
                      to="/book-online"
                      className="HeroBanner-BookWarp__Btn btn btn-primary"
                    >
                      <FontAwesomeIcon 
                        color="#ffffff" 
                        icon={faCalendarCheck} 
                        className="mr-2"
                      />
                      Book Online
                    </Link>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);

export default HeroArea;